(function () {
    'use strict';

    var form = document.getElementById('template-form');
    var tbody = document.getElementById('template-tbody');
    var totalDaysInput = document.getElementById('total-days-input');
    var updateRowsBtn = document.getElementById('update-rows-btn');
    var itemsJsonInput = document.getElementById('items-json-input');
    var rowTemplate = document.getElementById('template-row-template');

    if (!form || !tbody || !totalDaysInput || !updateRowsBtn || !itemsJsonInput || !rowTemplate) {
        return;
    }

    var FIELDS = ['online_lesson_content', 'remarks'];
    var MIN_DAYS = 1;
    var MAX_DAYS = 366;

    // 追加する行は Blade の <template id="template-row-template"> を複製する（見た目を既存の行とそろえるため）
    function buildRow(dayNumber) {
        var tr = rowTemplate.content.firstElementChild.cloneNode(true);
        tr.setAttribute('data-day', dayNumber);
        tr.querySelector('[data-day-number]').textContent = dayNumber;
        return tr;
    }

    updateRowsBtn.addEventListener('click', function () {
        var totalDays = parseInt(totalDaysInput.value, 10);
        if (isNaN(totalDays) || totalDays < MIN_DAYS || totalDays > MAX_DAYS) {
            alert('総日数は' + MIN_DAYS + '〜' + MAX_DAYS + 'の範囲で入力してください。');
            return;
        }

        var currentRows = tbody.querySelectorAll('tr[data-day]');
        if (totalDays > currentRows.length) {
            for (var i = currentRows.length + 1; i <= totalDays; i++) {
                tbody.appendChild(buildRow(i));
            }
        } else if (totalDays < currentRows.length) {
            for (var j = currentRows.length - 1; j >= totalDays; j--) {
                tbody.removeChild(currentRows[j]);
            }
        }
    });

    form.addEventListener('submit', function () {
        var rows = tbody.querySelectorAll('tr[data-day]');
        var items = {};
        rows.forEach(function (row) {
            var day = row.getAttribute('data-day');
            items[day] = {};
            FIELDS.forEach(function (field) {
                var el = row.querySelector('[data-field="' + field + '"]');
                if (el) items[day][field] = el.value;
            });
        });
        itemsJsonInput.value = JSON.stringify(items);
    });
})();
